<mat-dialog-content>
  <mbnm-moulding-merch [moulding]="moulding" [hangerType]="hangerType"></mbnm-moulding-merch>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">
    Buy Now
  </button>

  <button mat-flat-button mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>

